import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { ThemeProvider } from './contexts/ThemeContext'
import ThemeToggle from './components/ThemeToggle'
import Navigation from './components/Navigation'
import UIDChecker from './components/UIDChecker'
import FAQ from './components/FAQ'
import LegalPage from './pages/LegalPage'

function App() {
  return (
    <ThemeProvider>
      <Router>
        <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 dark:from-dark-900 dark:to-dark-800 transition-colors duration-300">
          <Navigation />
          <ThemeToggle />
          
          <Routes>
            <Route path="/" element={
              <main className="container mx-auto px-4 py-12">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center min-h-[calc(100vh-12rem)]">
                  {/* Linke Spalte - Info */}
                  <div className="lg:col-span-4 text-center lg:text-left">
                    <div className="space-y-6">
                      <div>
                        <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-3">
                          Vatly - Schnelle UID-Validierung
                        </h2>
                        <p className="text-gray-600 dark:text-gray-400 leading-relaxed">
                          Überprüfen Sie Umsatzsteuernummern <b>in Echtzeit.</b>
                        </p>
                      </div>
                      
                      <div className="space-y-4">
                        <div className="flex items-center gap-3 text-sm text-gray-600 dark:text-gray-400">
                          <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                          <span>Sofortige Validierung</span>
                        </div>
                        <div className="flex items-center gap-3 text-sm text-gray-600 dark:text-gray-400">
                          <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
                          <span>EU-weite Unterstützung</span>
                        </div>
                        <div className="flex items-center gap-3 text-sm text-gray-600 dark:text-gray-400">
                          <div className="w-2 h-2 bg-purple-500 rounded-full"></div>
                          <span>DSGVO-konform</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Rechte Spalte - Formular */}
                  <div className="lg:col-span-8 flex justify-center lg:justify-end">
                    <UIDChecker />
                  </div>
                </div>
              </main>
            } />
            
            <Route path="/faq" element={<FAQ />} />
            <Route path="/impressum" element={<LegalPage />} />
          </Routes>

          {/* Footer */}
          <footer className="bg-white dark:bg-dark-800 border-t border-gray-200 dark:border-dark-700">
            <div className="container mx-auto px-4 py-8">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                <div>
                  <h3 className="font-semibold text-gray-900 dark:text-white mb-3">Vatly</h3>
                  <p className="text-sm text-gray-600 dark:text-gray-400">
                    Professionelle UID-Prüfung für Unternehmen in der EU.
                  </p>
                </div>
                
                <div>
                  <h3 className="font-semibold text-gray-900 dark:text-white mb-3">Support</h3>
                  <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
                    Haben Sie Fragen? Wir helfen gerne!
                    <br/>
                    <a 
                    href={`mailto:${['help', '@', 'vatly', '.', 'at'].join('')}`}
                    className="text-primary-600 dark:text-primary-400 hover:text-primary-700 dark:hover:text-primary-300 text-sm"
                  >
                    {['help', '@', 'vatly', '.', 'at'].join('')}
                  </a>
                  </p>
                </div>
                
                <div>
                  <h3 className="font-semibold text-gray-900 dark:text-white mb-3">Rechtliches</h3>
                  <div className="space-y-2 text-sm">
                    <a href="/impressum" className="text-gray-600 dark:text-gray-400 hover:text-primary-600 dark:hover:text-primary-400">
                      Impressum/Datenschutz
                    </a>
                    <br/>
                    <a href="/faq" className="text-gray-600 dark:text-gray-400 hover:text-primary-600 dark:hover:text-primary-400">
                      FAQ
                    </a>
                  </div>
                </div>
              </div>
              
              <div className="border-t border-gray-200 dark:border-dark-700 mt-8 pt-6">
                <div className="flex flex-col md:flex-row items-center justify-between gap-4">
                  <p className="text-sm text-gray-500 dark:text-gray-400">
                    &copy; {new Date().getFullYear()} Vatly. Alle Rechte vorbehalten.
                  </p>
                  
                  <div className="flex items-center gap-2">
                    <div className="flex items-center gap-2">
                      <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
                      <span className="text-sm text-gray-600 dark:text-gray-400">Service Status:</span>
                      <span className="text-sm font-medium text-green-600 dark:text-green-400">Online</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </footer>
        </div>
      </Router>
    </ThemeProvider>
  )
}

export default App